import React from 'react';
import { DOCTOR_PROFILE } from '../api/constants';
import NavBar from '../components/common/NavBar';
import NewHeaderComponent from '../components/common/NewHeaderComponent';
import DoctorFilterStripUi from '../components/multiDocComponents/DoctorStrip';
import { getDoctorSelectorList } from '../store/idbHandler';

export default function MyProfile(): JSX.Element {
    const doctors = getDoctorSelectorList();

    const [selectedUserName, setSelectedUsername] = React.useState(
        () => doctors?.[0].professional.username,
    );

    const doctorsLength = doctors?.length || 0;

    return (
        <div className="grid h-full overflow-x-auto overflow-y-hidden grid-cols-queueGrid min-w-840 undefined">
            <NavBar />
            <div className="flex flex-col h-full col-span-11 overflow-hidden">
                <NewHeaderComponent title="My Profile" />
                <div className="flex space-x-4 overflow-x-scroll w-full">
                    {doctorsLength > 1
                        ? doctors?.map((doc) => (
                              <DoctorFilterStripUi
                                  key={doc.id}
                                  doctorName={`Dr. ${doc.personal.name.f || ''} ${
                                      doc.personal.name.l || ''
                                  }`.trim()}
                                  doctorPic={doc.personal.pic}
                                  onClick={() => {
                                      setSelectedUsername(doc.professional.username);
                                  }}
                                  showAptCount={false}
                                  isSelected={selectedUserName === doc.professional.username}
                              />
                          ))
                        : null}
                </div>
                <iframe height="100%" width="100%" src={DOCTOR_PROFILE(selectedUserName)}></iframe>
            </div>
        </div>
    );
}
